import { documentAttachmentDetails } from './documentAttachment.mjs';

export default function DocumentAttachment({ message, src, resolveSrc }) {
  const raw = documentAttachmentDetails(message, src);
  const { fileName, href, temporary } = documentAttachmentDetails(message,
    src || resolveSrc?.(raw.href, message.storagePath) || raw.href);
  return (
    <div style={{ minWidth:0 }}>
      <div style={{ display:'flex', gap:7, alignItems:'center', fontWeight:700 }}>
        <span aria-hidden="true">📄</span>
        <span style={{ overflowWrap:'anywhere' }}>{fileName}</span>
      </div>
      {href ? (
        <a href={href} target="_blank" rel="noopener noreferrer"
          aria-label={`Abrir documento: ${fileName}`}
          style={{ display:'inline-block', marginTop:6, padding:'5px 10px', border:'1px solid currentColor',
            borderRadius:7, color:'inherit', textDecoration:'none', fontSize:12, fontWeight:700 }}>
          Abrir documento ↗
        </a>
      ) : (
        <div role="status" style={{ fontSize:11, marginTop:5 }}>
          Arquivo indisponível. Solicite o reenvio.
        </div>
      )}
      {href && temporary && (
        <div role="status" style={{ fontSize:11, marginTop:5, opacity:0.85 }}>
          Sem cópia permanente confirmada. O link do WhatsApp pode expirar; se não abrir, solicite o reenvio.
        </div>
      )}
    </div>
  );
}
